import { render } from "./Refund.vue?vue&type=template&id=ca45c750"
import script from "./Refund.vue?vue&type=script&lang=js"
export * from "./Refund.vue?vue&type=script&lang=js"
script.render = render

export default script